import { formatCategoryLabel } from "./TemplatesForm.constants";
import type {
  TemplateScalarVariable,
  TemplateVariablesResponse,
} from "./TemplatesForm.types";

export interface ScalarGroup {
  categoryKey: string;
  label: string;
  vars: TemplateScalarVariable[];
}

const matchesNeedle = (haystack: string, needle: string) =>
  haystack.toLocaleLowerCase().includes(needle);

const variableMatches = (v: TemplateScalarVariable, needle: string) =>
  matchesNeedle(v.label, needle) ||
  matchesNeedle(v.key, needle) ||
  matchesNeedle(v.placeholder, needle);

// Фильтрация и группировка скаляров по категориям с поиском. Категории
// итерируем через Object.entries — порядок зависит от ответа бэка.
export const buildScalarGroups = (
  data: TemplateVariablesResponse | null,
  query: string,
): ScalarGroup[] => {
  if (!data) return [];
  const needle = query.trim().toLocaleLowerCase();
  return Object.entries(data.scalars)
    .map(([categoryKey, vars]) => ({
      categoryKey,
      label: formatCategoryLabel(categoryKey),
      vars: needle ? vars.filter((v) => variableMatches(v, needle)) : vars,
    }))
    .filter((group) => group.vars.length > 0);
};

export const TYPE_BADGE: Record<string, string> = {
  string: "txt",
  number: "num",
  date: "date",
  boolean: "bool",
};
